// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-control,
.ui-sortable-handle {
  background: transparent !important;
}

.form-field,
.form-elements {
  background: transparent !important;
}

.main-container {
  display: flex;
  flex-direction: column;
  padding: 1.2rem;
  background-color: transparent;
  border-radius: 12px;
}

.form-builder-area {
  margin: 1rem 0 1rem 0;
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow-y: auto;
}

.button-group {
  display: flex;
  gap: 1rem;
}

.disabledMenuItem {
  pointer-events: none !important;
  opacity: 0.6;
}

.select-field .minlength-wrap {
  display: none !important;
}

.radio-group-field .minlength-wrap {
  display: none !important;
}

.checkbox-field .minlength-wrap {
  display: none !important;
}

.textarea-field .minlength-wrap {
  display: none !important;
}

.textarea-field .maxlength-wrap {
  display: none !important;
}

.form-elements .access-wrap,
.className-wrap,
.label-wrap,
.value-wrap,
.subtype-wrap,
.field-options,
.inline-wrap,
.toggle-wrap {
  display: none !important;
}

/* scrollbar for side list of form fields */
.cb-wrap,
.sticky-controls {
  max-height: 500px;
  overflow-y: auto;
  margin-right: 15px;
}

/* change the content of the empty drag area */
.form-wrap.form-builder .stage-wrap.empty::after {
  content: 'Select an item or drag and drop it into this area to start building your form!' !important;
}

/* scrollbar for form builder area when it's empty */
.form-wrap.form-builder .stage-wrap.empty {
  max-height: 500px !important;
  min-height: 100px !important;
  overflow-y: auto;
}

/* scrollbar for the form builder area when it is not empty. Wrote it separately  */
.form-wrap.form-builder .stage-wrap {
  max-height: 500px !important;
  min-height: 100px !important;
  overflow-y: auto;
}

/* scrollbar styles for both the sections START */
.cb-wrap::-webkit-scrollbar,
.sticky-controls::-webkit-scrollbar,
.form-wrap.form-builder .stage-wrap.empty::-webkit-scrollbar,
.form-wrap.form-builder .stage-wrap::-webkit-scrollbar {
  width: 0.4rem;
}

.cb-wrap::-webkit-scrollbar-track,
.sticky-controls::-webkit-scrollbar-track,
.form-wrap.form-builder .stage-wrap.empty::-webkit-scrollbar-track,
.form-wrap.form-builder .stage-wrap::-webkit-scrollbar-track {
  background-color: transparent;
}

.cb-wrap::-webkit-scrollbar-thumb,
.sticky-controls::-webkit-scrollbar-thumb,
.form-wrap.form-builder .stage-wrap.empty::-webkit-scrollbar-thumb,
.form-wrap.form-builder .stage-wrap::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
  cursor: pointer;
}
/* scrollbar styles for both the sections END */


.cb-wrap.sticky-controls{
  min-width: 25%;
}

.no-matches {
  pointer-events: none;
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/style/scss/FormBuilder/index.css"],"names":[],"mappings":"AAAA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;EAQE,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,oGAAoG;AACtG;;AAEA,oDAAoD;AACpD;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,mFAAmF;AACnF;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;EAIE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;AACA,+CAA+C;;;AAG/C;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd","sourcesContent":[".input-control,\n.ui-sortable-handle {\n  background: transparent !important;\n}\n\n.form-field,\n.form-elements {\n  background: transparent !important;\n}\n\n.main-container {\n  display: flex;\n  flex-direction: column;\n  padding: 1.2rem;\n  background-color: transparent;\n  border-radius: 12px;\n}\n\n.form-builder-area {\n  margin: 1rem 0 1rem 0;\n  display: flex;\n  flex-direction: column;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.button-group {\n  display: flex;\n  gap: 1rem;\n}\n\n.disabledMenuItem {\n  pointer-events: none !important;\n  opacity: 0.6;\n}\n\n.select-field .minlength-wrap {\n  display: none !important;\n}\n\n.radio-group-field .minlength-wrap {\n  display: none !important;\n}\n\n.checkbox-field .minlength-wrap {\n  display: none !important;\n}\n\n.textarea-field .minlength-wrap {\n  display: none !important;\n}\n\n.textarea-field .maxlength-wrap {\n  display: none !important;\n}\n\n.form-elements .access-wrap,\n.className-wrap,\n.label-wrap,\n.value-wrap,\n.subtype-wrap,\n.field-options,\n.inline-wrap,\n.toggle-wrap {\n  display: none !important;\n}\n\n/* scrollbar for side list of form fields */\n.cb-wrap,\n.sticky-controls {\n  max-height: 500px;\n  overflow-y: auto;\n  margin-right: 15px;\n}\n\n/* change the content of the empty drag area */\n.form-wrap.form-builder .stage-wrap.empty::after {\n  content: 'Select an item or drag and drop it into this area to start building your form!' !important;\n}\n\n/* scrollbar for form builder area when it's empty */\n.form-wrap.form-builder .stage-wrap.empty {\n  max-height: 500px !important;\n  min-height: 100px !important;\n  overflow-y: auto;\n}\n\n/* scrollbar for the form builder area when it is not empty. Wrote it separately  */\n.form-wrap.form-builder .stage-wrap {\n  max-height: 500px !important;\n  min-height: 100px !important;\n  overflow-y: auto;\n}\n\n/* scrollbar styles for both the sections START */\n.cb-wrap::-webkit-scrollbar,\n.sticky-controls::-webkit-scrollbar,\n.form-wrap.form-builder .stage-wrap.empty::-webkit-scrollbar,\n.form-wrap.form-builder .stage-wrap::-webkit-scrollbar {\n  width: 0.4rem;\n}\n\n.cb-wrap::-webkit-scrollbar-track,\n.sticky-controls::-webkit-scrollbar-track,\n.form-wrap.form-builder .stage-wrap.empty::-webkit-scrollbar-track,\n.form-wrap.form-builder .stage-wrap::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.cb-wrap::-webkit-scrollbar-thumb,\n.sticky-controls::-webkit-scrollbar-thumb,\n.form-wrap.form-builder .stage-wrap.empty::-webkit-scrollbar-thumb,\n.form-wrap.form-builder .stage-wrap::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 10px;\n  cursor: pointer;\n}\n/* scrollbar styles for both the sections END */\n\n\n.cb-wrap.sticky-controls{\n  min-width: 25%;\n}\n\n.no-matches {\n  pointer-events: none;\n  color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
